import React from 'react';
import styled from 'styled-components';

import { SvgIcon } from 'Components/Base';
import { useVideoPlayer } from 'Context/VideoPlayer';
import { get as getTheme } from 'Components/Base/constants';

import VjsComponent from '../VjsComponent';

const StyledVjsComponent = styled(VjsComponent)`
  && .vjs-control.vjs-button {
    width: ${({ size }) => size};
    height: ${({ size }) => size};
    background-color: transparent;
    border-radius: 50%;
    position: relative;
    cursor: pointer;
  }
  && .video-js .vjs-button > .vjs-icon-placeholder {
    display: none;
  }
`;

const StyledSvgIcon = styled(SvgIcon)`
  display: ${({ active }) => (active ? 'block' : 'none')};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background: ${getTheme('colors.whites.10')};
  color: ${getTheme('colors.blacks.8')};
`;

const VideoBigPlayButton = ({ size = SIZE.NORMAL }) => {
  const { player, videoState, VIDEO_STATE } = useVideoPlayer();
  return (
    <StyledVjsComponent
      player={player}
      componentType={VjsComponent.COMPONENT_TYPES.PLAY_TOGGLE}
      size={size}
    >
      <StyledSvgIcon
        icon={SvgIcon.ICON_LIST.PAUSE}
        active={videoState === VIDEO_STATE.PLAY}
        size={size}
      />
      <StyledSvgIcon
        icon={SvgIcon.ICON_LIST.PLAY}
        active={videoState === VIDEO_STATE.PAUSED}
        size={size}
      />
      <StyledSvgIcon
        icon={SvgIcon.ICON_LIST.REPLAY}
        active={videoState === VIDEO_STATE.ENDED}
        size={size}
      />
    </StyledVjsComponent>
  );
};

const SIZE = {
  NORMAL: '46px',
  BIG: '80px',
};

VideoBigPlayButton.SIZE = SIZE;

export default VideoBigPlayButton;
